import React from "react";

interface LightboxProps {
  images: string[];
  openIdx: number; // index de l’image à afficher (0-based)
  onClose: () => void;
}

export default function Lightbox({ images, openIdx, onClose }: LightboxProps) {
  const [idx, setIdx] = React.useState(openIdx);

  React.useEffect(() => setIdx(openIdx), [openIdx]);

  const prev = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIdx((i) => (i === 0 ? images.length - 1 : i - 1));
  };
  const next = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIdx((i) => (i === images.length - 1 ? 0 : i + 1));
  };

  if (!images.length) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-start justify-center bg-black/80 pt-28"
      onClick={onClose}
    >
      <div className="relative" onClick={(e) => e.stopPropagation()}>
        {/* image */}
        <img
          src={images[idx]}
          alt={`lightbox-${idx}`}
          className="max-h-[calc(90vh-110px)] max-w-[90vw] object-contain rounded-lg"
          loading="lazy"
          onClick={(e) => e.stopPropagation()}
        />

        {/* close */}
        <button
          onClick={onClose}
          aria-label="Fermer"
          title="Fermer"
          className="absolute -top-4 -right-6 w-10 h-10 flex items-center justify-center
                     rounded-full bg-white text-black text-2xl leading-none shadow
                     hover:bg-black hover:text-white transition border-[1px] border-slate-500"
        >
          ✕
        </button>

        {/* nav */}
        {images.length > 1 && (
          <>
            <button
              onClick={prev}
              aria-label="Précédent"
              className="absolute left-0 top-1/2 -translate-y-1/2
                         w-10 h-10 flex  justify-center
                         rounded-full bg-white text-black text-2xl shadow
                         hover:bg-black hover:text-white transition font-semibold ml-1 border-[1px] border-slate-500"
            >
              ‹
            </button>

            <button
              onClick={next}
              aria-label="Suivant"
              className="absolute right-0 top-1/2 -translate-y-1/2
                         w-10 h-10 flex justify-center
                         rounded-full bg-white text-black text-2xl shadow
                         hover:bg-black hover:text-white transition font-semibold mr-1 border-[1px] border-slate-500"
            >
              ›
            </button>
          </>
        )}
      </div>
    </div>
  );
}
